import React, { useState, useEffect, useCallback, memo } from "react";
import { useSelector } from "react-redux";
import {useNavigate} from "react-router-dom"
import axios from "axios";

const CreateBranch = memo(() => {
  const { currentUser } = useSelector((state) => state.user);
  const [formData, setFormData] = useState({
    name: "",
    location: "",
    agent: ""
  });
  const [agents, setAgents] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchAgents = useCallback(async () => {
    try {
      const response = await axios.get("/api/user/branch");
      setAgents(response.data);
    } catch (err) {
      setError("Error fetching agents");
      console.error("Fetch agents error:", err);
    }
  }, []);

  useEffect(() => {
    fetchAgents();
  }, [fetchAgents]);

  const handleChange = useCallback((e) => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        `/api/branch/createbranch/${currentUser._id}`,
        formData
      );
      if (response.data.success) {
        alert("Branch created successfully!");
        navigate("/admin");
      } else {
        setError(response.data.message || "Failed to create branch");
      }
    } catch (error) {
      setError(error.response?.data?.message || "Error creating branch");
      console.error("Create error:", error);
    } finally {
      setLoading(false);
    }
  }, [formData, currentUser?._id, navigate]);

  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-pt-10 tw-bg-slate-100 tw-min-h-screen">
      <form
        onSubmit={handleSubmit}
        className="tw-w-full tw-max-w-md tw-flex tw-flex-col tw-gap-6 tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-md"
      >
        <h2 className="tw-text-xl tw-font-semibold tw-text-center">Create New Branch</h2>
        
        <div>
          <label className="tw-block tw-text-gray-700 tw-mb-2" htmlFor="name">
            Branch Name
          </label>
          <input
            type="text"
            placeholder="Full Name"
            id="name"
            required
            value={formData.name}
            onChange={handleChange}
            className="tw-w-full tw-h-10 tw-rounded-lg tw-border tw-border-slate-300 tw-p-3 focus:tw-outline-none focus:tw-ring focus:tw-ring-blue-500"
          />
        </div>

        <div>
          <label className="tw-block tw-text-gray-700 tw-mb-2" htmlFor="location">
            Location
          </label>
          <input
            type="text"
            placeholder="Location"
            id="location"
            required
            value={formData.location}
            onChange={handleChange}
            className="tw-w-full tw-h-10 tw-rounded-lg tw-border tw-border-slate-300 tw-p-3 focus:tw-outline-none focus:tw-ring focus:tw-ring-blue-500"
          />
        </div>

        <div>
          <label className="tw-block tw-text-gray-700 tw-mb-2" htmlFor="agent">
            Agent
          </label>
          <select
            id="agent"
            value={formData.agent}
            onChange={handleChange}
            className="tw-w-full tw-rounded-lg tw-border tw-border-slate-300 tw-p-2.5 focus:tw-outline-none focus:tw-ring focus:tw-ring-blue-500"
            required
          >
            <option value="">Select Agent</option>
            {agents.map((agent) => (
              <option key={agent._id} value={agent.username}>
                {agent.username}
              </option>
            ))}
          </select>
        </div>

        <button
          disabled={loading}
          type="submit"
          className="tw-w-full tw-font-semibold hover:tw-bg-white hover:tw-text-blue-600 hover:tw-border hover:tw-border-blue-400 tw-p-2 tw-rounded-lg tw-text-white tw-bg-blue-600 disabled:tw-opacity-50"
        >
          {loading ? "Creating..." : "Create Branch"}
        </button>

        {error && <p className="tw-text-red-500 tw-text-center">{error}</p>}
      </form>
    </div>
  );
});

export default CreateBranch;